import React from "react";
import {connect} from "react-redux";
import {change, Field} from "redux-form";
import {injectIntl} from "react-intl";

import ExpandSection from "../../Generic/expandSection";
import {ACCOUNT_SECTIONS} from "./sectionNames";
import {FormCheckBoxField} from "../FormField";
import {toggleSectionOpened} from "../AccountActions";
import {PARTS} from "../../../schemas/accessRightsModel";


const ReceiptSettingsSection = (props) => {

  const {sectionsOpened, toggleSectionOpened, canEditFields, intl, formValues, change} = props;

  const {receiptSettings} = formValues;
  const parsedSettings = receiptSettings ? JSON.parse(receiptSettings) : {};
  // console.log("parsedSettings", parsedSettings);

  const updateCheckBoxField = (input) => {
    const name = input.name.split("receiptSettings.")[1];
    parsedSettings[name] = !parsedSettings[name];
    // console.log("updatedSettings", parsedSettings);
    change('newEntity', "receiptSettings", JSON.stringify(parsedSettings));
  };

  return (
    <ExpandSection opened={sectionsOpened.includes(ACCOUNT_SECTIONS.receipt_settings)}
                   onClick={() => toggleSectionOpened(ACCOUNT_SECTIONS.receipt_settings)}
                   title="Receipt Settings">
      <div className="acc-container">
        <div className="acc-container__row acc-container__row--united">
          <div className="acc-block">
            <Field name="receiptSettings.hideSignatureField"
                   format={() => !parsedSettings["hideSignatureField"]}
                   labelEnabled={"Show Signature Field"}
                   labelDisabled={"Show Signature Field"}
                   component={FormCheckBoxField}
                   disabled={!canEditFields}
                   onChecked={updateCheckBoxField}/>
          </div>
          <div className="acc-block">
            <Field name="receiptSettings.signIsRequired"
                   format={() => parsedSettings["signIsRequired"]}
                   labelEnabled={"Signature Is Required"}
                   labelDisabled={"Signature Is Required"}
                   component={FormCheckBoxField}
                   disabled={!canEditFields || parsedSettings["hideSignatureField"]}
                   onChecked={updateCheckBoxField}/>
          </div>
        </div>
        <div className="acc-container__row">
          <div className="acc-block">
            <Field name="receiptSettings.doNotFillNameAndDate"
                   format={() => !parsedSettings["doNotFillNameAndDate"]}
                   labelEnabled={"Auto Fill Name and Date"}
                   labelDisabled={"Auto Fill Name and Date"}
                   component={FormCheckBoxField}
                   disabled={!canEditFields}
                   onChecked={updateCheckBoxField}/>
          </div>
        </div>
        <div className="acc-container__row">
          <div className="acc-block">
            <Field name="receiptSettings.showThumbnailsAndDescriptions"
                   format={() => parsedSettings["showThumbnailsAndDescriptions"]}
              // labelEnabled={intl.formatMessage({id: "account.pingWidget.usePingWidget"})}
              // labelDisabled={intl.formatMessage({id: "account.pingWidget.usePingWidget"})}
                   labelEnabled={"Show Thumbnails And Descriptions"}
                   labelDisabled={"Show Thumbnails And Descriptions"}
                   component={FormCheckBoxField}
                   disabled={!canEditFields}
                   onChecked={updateCheckBoxField}/>
          </div>
        </div>
        <div className="acc-container__row">
          <div className="acc-block">
            <Field name="receiptSettings.createCostReceipt"
                   format={() => parsedSettings["createCostReceipt"]}
              // labelEnabled={intl.formatMessage({id: "account.pingWidget.usePingWidget"})}
              // labelDisabled={intl.formatMessage({id: "account.pingWidget.usePingWidget"})}
                   labelEnabled={"Create Cost Receipt"}
                   labelDisabled={"Create Cost Receipt"}
                   component={FormCheckBoxField}
                   disabled={!canEditFields}
                   onChecked={updateCheckBoxField}/>
          </div>
        </div>
      </div>
    </ExpandSection>
  )
};

const mapStateToProps = (store) => {
  const {sectionsOpened, accountPageInfo} = store.accountState;
  return {
    sectionsOpened,
    canEditFields: accountPageInfo.canEditFields,
    formValues: (store.form && store.form.newEntity && store.form.newEntity.values) || {},
  };
};

const mapDispatchToProps = {
  toggleSectionOpened,
  change,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(ReceiptSettingsSection)
);
